import React, { useState } from "react";
import { StyleSheet, Text, View } from "react-native";
import { Entypo, Ionicons } from "@expo/vector-icons";

import Colors from "../../../Resources/Color";
import FloatingMenu from "../../Components/FloatingMenu";
import HoverableTouchableOpacity from "../../Components/HoverableTouchableOpacity";
import { useDevice } from "../../_layout";

function NutritionEditorActionsMenu({
  items = [],
  onAction = null,
  width = 230,
}) {
  const { isMobile } = useDevice();
  const [isOpen, setIsOpen] = useState(false);
  const [isTriggerHovered, setIsTriggerHovered] = useState(false);
  const menuItems = Array.isArray(items) ? items.filter(Boolean) : [];

  if (menuItems.length === 0 || typeof onAction !== "function") {
    return null;
  }

  return (
    <FloatingMenu
      placement="bottom-end"
      width={width}
      items={menuItems}
      open={isOpen}
      onOpenChange={setIsOpen}
      triggerContainerStyle={styles.cardIconButton}
      trigger={
        <View
          style={{
            opacity: isTriggerHovered ? 1 : 0.75,
            transition: "opacity 150ms ease",
          }}
          onMouseEnter={() => !isMobile && setIsTriggerHovered(true)}
          onMouseLeave={() => setIsTriggerHovered(false)}
        >
          <Entypo
            name="dots-three-horizontal"
            size={16}
            color={isTriggerHovered ? Colors.darkgrayColor : Colors.grayColor}
          />
        </View>
      }
      renderItem={({ item, close }) => (
        <HoverableTouchableOpacity
          disabled={item?.disabled === true}
          style={[
            styles.menuItemRow,
            item?.disabled ? styles.menuItemRowDisabled : null,
          ]}
          hoverStyle={styles.menuItemHover}
          onPress={(event) => {
            event?.stopPropagation?.();
            if (item?.disabled) {
              return;
            }

            onAction(item?.key, item);
            close();
          }}
          title={item?.label}
        >
          {item?.icon?.type === "ionicons" ? (
            <Ionicons
              name={item.icon.name}
              size={14}
              color={
                item?.disabled
                  ? Colors.grayColor
                  : item?.isDanger
                    ? Colors.redColor
                    : Colors.darkgrayColor
              }
            />
          ) : null}
          <Text
            style={[
              styles.menuItemText,
              item?.disabled ? styles.menuItemTextDisabled : null,
              item?.isDanger ? styles.menuItemDanger : null,
            ]}
          >
            {item?.label}
          </Text>
        </HoverableTouchableOpacity>
      )}
    />
  );
}

const styles = StyleSheet.create({
  cardIconButton: {
    alignItems: "center",
    borderRadius: 10,
    height: 28,
    justifyContent: "center",
    width: 28,
  },
  menuItemRow: {
    alignItems: "center",
    borderRadius: 8,
    flexDirection: "row",
    gap: 8,
    paddingHorizontal: 10,
    paddingVertical: 10,
  },
  menuItemRowDisabled: {
    opacity: 0.55,
  },
  menuItemHover: {
    backgroundColor: Colors.hoveredGray,
  },
  menuItemText: {
    color: Colors.blackColor,
    fontSize: 12,
    fontWeight: "500",
  },
  menuItemTextDisabled: {
    color: Colors.grayColor,
  },
  menuItemDanger: {
    color: Colors.redColor,
  },
});

export default NutritionEditorActionsMenu;
